import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { StyledParentBox } from "../MenuBar/partial/StyledBox.partial";

type FleetLocationFilterCardsProps = {
  locations: Array<{ id: number; name: string; picturePath?: string | null }>;
  selectedLocationIds: number[];
  onToggleLocation: (locationId: number) => void;
  onClear: () => void;
};

export function FleetLocationFilterCards({
  locations,
  selectedLocationIds,
  onToggleLocation,
  onClear
}: Readonly<FleetLocationFilterCardsProps>) {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1 }}>
      <StyledParentBox
        picturePath={undefined}
        onClick={onClear}
        data-testid="fleet-location-filter-card-all"
        sx={{
          minWidth: "140px",
          minHeight: "58px",
          padding: "10px 12px",
          fontSize: 14,
          borderRadius: "8px",
          boxShadow:
            selectedLocationIds.length === 0
              ? `0 0 0 2px ${theme.palette.primary.main}`
              : `0 0 0 1px ${theme.palette.divider}`
        }}
      >
        <Typography sx={{ fontSize: "inherit", fontWeight: 600 }}>{t("All locations")}</Typography>
      </StyledParentBox>

      {locations.map(location => {
        const isSelected = selectedLocationIds.includes(location.id);
        return (
          <StyledParentBox
            key={location.id}
            data-testid={`fleet-location-filter-card-${location.id}`}
            picturePath={location.picturePath ?? undefined}
            onClick={() => onToggleLocation(location.id)}
            sx={{
              minWidth: "140px",
              minHeight: "58px",
              padding: "10px 12px",
              fontSize: 14,
              borderRadius: "8px",
              boxShadow: isSelected
                ? `0 0 0 2px ${theme.palette.primary.main}`
                : `0 0 0 1px ${theme.palette.divider}`
            }}
          >
            <Typography
              sx={{
                fontSize: "inherit",
                fontWeight: 600,
                overflow: "hidden",
                textOverflow: "ellipsis"
              }}
            >
              {location.name}
            </Typography>
          </StyledParentBox>
        );
      })}
    </Box>
  );
}
